// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { disablePageZoom } from '@/utils/disable-zoom'

// 引入 mock 数据（仅在开发环境）
if (process.env.NODE_ENV === 'development') {
  require('@/mock')
}

// vConsole：URL 携带 ?vconsole=1 时启用
if (typeof window !== 'undefined' && /[?&]vconsole=1\b/.test(window.location.search)) {
  // eslint-disable-next-line global-require
  const VConsole = require('vconsole')
  // eslint-disable-next-line no-new
  new VConsole()
}

Vue.config.productionTip = false
disablePageZoom()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js